// src/app/core/services/claim-analytics-api.service.ts

import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '@env';
import {
  ClaimOverviewRequest, ClaimOverviewRow,
  ClaimTimeSeriesRequest, ClaimTimeSeriesRow,
  ClaimBreakdownRequest, ClaimBreakdownRow,
  ClaimRankingsRequest, ClaimRankingsRow,
  ClaimComparisonRequest, ClaimComparisonRow,
  ClaimProductSummary, ClaimProductConfig,
  ClaimCauseLookupItem, HealthBenefitTypeLookupItem,
} from '@shared/models/claim-analytics.model';

@Injectable({ providedIn: 'root' })
export class ClaimAnalyticsApiService {
  private readonly baseUrl = `${environment.apiUrl}/claim-analytics`;
  private readonly http = inject(HttpClient);

  // ── Config & Lookups ──
  getProducts(): Observable<ClaimProductSummary[]> {
    return this.http.get<ClaimProductSummary[]>(`${this.baseUrl}/products`);
  }

  getConfig(claimTypeId: number): Observable<ClaimProductConfig> {
    return this.http.get<ClaimProductConfig>(`${this.baseUrl}/config/${claimTypeId}`);
  }

  getCascoCauses(): Observable<ClaimCauseLookupItem[]> {
    return this.http.get<ClaimCauseLookupItem[]>(`${this.baseUrl}/lookups/casco-causes`);
  }

  getHealthBenefitTypes(): Observable<HealthBenefitTypeLookupItem[]> {
    return this.http.get<HealthBenefitTypeLookupItem[]>(`${this.baseUrl}/lookups/health-benefit-types`);
  }

  // ── Analytics ──
  getOverview(req: ClaimOverviewRequest): Observable<ClaimOverviewRow[]> {
    return this.http.post<ClaimOverviewRow[]>(`${this.baseUrl}/overview`, req);
  }

  getTimeSeries(req: ClaimTimeSeriesRequest): Observable<ClaimTimeSeriesRow[]> {
    return this.http.post<ClaimTimeSeriesRow[]>(`${this.baseUrl}/timeseries`, req);
  }

  getBreakdown(req: ClaimBreakdownRequest): Observable<ClaimBreakdownRow[]> {
    return this.http.post<ClaimBreakdownRow[]>(`${this.baseUrl}/breakdown`, req);
  }

  getRankings(req: ClaimRankingsRequest): Observable<ClaimRankingsRow[]> {
    return this.http.post<ClaimRankingsRow[]>(`${this.baseUrl}/rankings`, req);
  }

  getComparison(req: ClaimComparisonRequest): Observable<ClaimComparisonRow[]> {
    return this.http.post<ClaimComparisonRow[]>(`${this.baseUrl}/comparison`, req);
  }
}
